// C2 · Cart style › "Cart photo = the variant's 2nd photo": the cart drawer and cart page show, for each item, the
// SECOND photo of its variant (same order as the product page gallery; it shows the plush with its size) instead of
// the variant's main photo (often a tall photo of a child, cropped to a face in the cart's frame).
// - A cart photo stays hidden until its right photo is set, so the previous item's photo never flashes.
// - Photos are loaded right away (not lazily).
// - Known photos come from the product page (c2-product.js stores them when adding) or from a small request per
//   product (sections/c2-cart-image.liquid), cached for the visit.
(() => {
  const KEY = "c2-cart-img-2";   // v2: 2nd photo (the old cache held colour photos)
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch (e) { return {}; } };
  const write = (m) => { try { sessionStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {} };
  let map = read();
  const asked = {};

  window.c2CartImages = {   // used by c2-product.js when adding to the cart
    remember(entries) { map = Object.assign(read(), entries); write(map); },
  };

  async function load(handle) {
    if (asked[handle]) return asked[handle];
    asked[handle] = (async () => {
      try {
        const html = await (await fetch(`${root}products/${handle}?section_id=c2-cart-image`)).text();
        const m = html.match(/<script type="application\/json" data-c2-cart-images>([\s\S]*?)<\/script>/);
        const got = m ? JSON.parse(m[1]) : {};
        map = Object.assign(read(), got); write(map);
      } catch (e) {}
    })();
    return asked[handle];
  }

  // Our own clean <img> in the photo frame (the theme's image keeps its lazy-loading / hover / blend logic and showed
  // odd sizes): the original 4:5 photo, no blend, no filter, no zoom. The theme's image is hidden by CSS.
  function setPhoto(img, url, id) {
    const frame = img.closest(".media") || img.parentElement;
    let own = frame.querySelector(":scope > img.c2-cart-photo");
    const src = url || img.getAttribute("src");
    if (!src) { img.dataset.c2Ready = id; return; }
    if (own && own.dataset.for === id && own.getAttribute("src") === src) { img.dataset.c2Ready = id; return; }
    if (!own) {
      own = document.createElement("img");
      own.className = "c2-cart-photo";
      own.alt = img.alt || "";
      own.decoding = "async";
      own.loading = "eager";
      frame.appendChild(own);
    }
    own.dataset.for = id;
    own.classList.remove("is-in");
    own.onload = () => { own.classList.add("is-in"); };
    own.setAttribute("src", src);
    if (own.complete && own.naturalWidth) own.classList.add("is-in");
    img.dataset.c2Ready = id;
  }

  function apply() {
    document.querySelectorAll(".cart-items__table-row[data-key]").forEach((row) => {
      const img = row.querySelector(".cart-items__media img:not(.c2-cart-photo)");
      if (!img) return;
      const id = String(row.dataset.key).split(":")[0];
      if (img.dataset.c2Ready && img.dataset.c2Ready !== id) delete img.dataset.c2Ready;   // row reused for another item
      if (img.dataset.c2Ready === id) return;
      if (id in map) return setPhoto(img, map[id], id);
      const link = row.querySelector('a[href*="/products/"]');
      const handle = link && (link.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle) return setPhoto(img, null, id);
      load(handle).then(() => setPhoto(img, map[id] ?? null, id));
    });
    // Gift line and anything else without a variant: shown as is.
    document.querySelectorAll(".cart-items__table-row:not([data-key]) .cart-items__media img").forEach((img) => {
      img.setAttribute("loading", "eager");
      img.dataset.c2Ready = "x";
    });
  }

  // Speed (12 Oct 2026): the page changes hundreds of times while it loads (lazy photos, menus, apps). A live list of
  // cart rows costs nothing to check, so nothing runs while there is no cart row.
  const rows = document.getElementsByClassName("cart-items__table-row");
  let queued = false;
  const schedule = () => {
    if (queued || !rows.length) return;
    queued = true;
    queueMicrotask(() => { queued = false; apply(); });
  };
  // Only the cart's own sections are watched (cart drawer, cart page): watching the whole page cost ~0.3 s of phone CPU
  // while it loads. The section wrapper is kept when the theme redraws the cart, so the watch survives updates.
  const watch = () => {
    const mo = new MutationObserver(schedule);
    const opts = { childList: true, subtree: true, attributes: true, attributeFilter: ["data-key", "src"] };
    const spots = [...new Set([...document.querySelectorAll("cart-items-component")].map((c) => c.closest(".shopify-section") || c))];
    (spots.length ? spots : [document.documentElement]).forEach((el) => mo.observe(el, opts));
    schedule();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch); else watch();
})();
